import { ReactNode } from 'react'

interface MainLayoutProps {
  children: ReactNode
}

export function MainLayout({ children }: MainLayoutProps) {
  return (
  <main id="app" className="w-full min-h-dvh">
      {children}
    </main>
  )
}
